import Axios from 'axios';
import { getEndpointURL } from './config';
Axios.defaults.withCredentials = true;

const endpointURL = getEndpointURL();
const headers = { 'Content-Type': 'application/json; charset=utf-8' };

const GetStorage = async () => {
    return Axios({
        method: 'POST',
        headers,
        data: {},
        url: `${endpointURL}/api/storage/get-storage`
    })
}

const DeleteStorage = async (paths) => {
    return Axios({
        method: 'POST',
        headers,
        data: {
            paths
        },
        url: `${endpointURL}/api/storage/delete-storage`
    })
}

const DownloadStorage = async (paths) => {
    return Axios({
        method: 'POST',
        headers,
        responseType: 'blob',
        data: {
            paths,
        },
        url: `${endpointURL}/api/storage/download-storage`
    })
}

const AddNewSubDirectory = async (parentPath, directoryName) => {
    return Axios({
        method: 'POST',
        headers,
        data: {
            parentPath,
            directoryName,
        },
        url: `${endpointURL}/api/storage/add-new-sub-directory`
    })
}

const UpdateDirectory = async (currentPath, directoryName) => {
    return Axios({
        method: 'POST',
        headers,
        data: {
            currentPath,
            directoryName,
        },
        url: `${endpointURL}/api/storage/update-directory`
    })
}

const UploadFiles = async function (files, path, onUploadProgress) {
    const formData = new FormData();

    for(let file of files) {
        formData.append('multi-files', file);
    }

    return Axios({
        method: 'POST',
        headers,
        data: formData,
        url: `${endpointURL}/api/storage/upload-files?path=${path}`,
        onUploadProgress,
    })
}

const ConvertFilePath = async (path) => {
    return Axios({
        method: 'POST',
        headers,
        data: {
            path
        },
        url: `${endpointURL}/api/storage/convert-file-path`
    })
}

export {
    GetStorage,
    DeleteStorage,
    DownloadStorage,
    AddNewSubDirectory,
    UpdateDirectory,
    UploadFiles,
    ConvertFilePath,
};
